module.exports = __webpack_public_path__ + "media/images/arrow_right_peppermint-153d2da22ebb03de75912797c4051dbc.png";